Queue = require 'promise-queue'
Queue.configure require('bluebird')
